{
  "version": 1,
  "asset_id": "600edb81-8430-4f03-b83b-47702e017094",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/600edb81-8430-4f03-b83b-47702e017094/libera1.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/600edb81-8430-4f03-b83b-47702e017094/libera1.webp",
  "original_filename": "libera1.webp",
  "size": 41960,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:45Z"
}
